<script setup>
import HiddenInput from "~/components/atoms/HiddenInput.vue";
import ExpandIcon from "~/components/icons/ExpandIcon.vue";

const emit = defineEmits(['update:modelValue', 'focusout', 'focusin', 'change'])

const props = defineProps({
  modelValue: String | Number,
  name: String,
  disabled: {
    type: Boolean,
    default: false
  },
  options: Array,
})

const root = ref(null)
const selectActive = ref(false);
const value = ref(props.modelValue)
const prefix = ref(props.options.find(option => option.key == value.value)?.prefix)

watch(() => value.value, (val) => {
  emit('update:modelValue', val)
  emit('change', val)
})

const onDocumentClick = (event) => {
  if (!selectActive.value || !root.value) {
    return
  }

  if (!root.value.contains(event.target)) {
    selectActive.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', onDocumentClick, true)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', onDocumentClick, true)
})
</script>

<template>
  <div ref="root" class="select-input">
    <div @click="selectActive=!selectActive" class="row full-width select-container"
         :class="{active:!disabled && selectActive}">
      <HiddenInput hidden :name="name" v-model="value"/>

      <div class="row full-width g-8">
        <div v-if="prefix" class="prefix" v-html="prefix"></div>

        <HiddenInput disabled :value="options.find(option => option.key == value)?.value"/>
      </div>

      <ExpandIcon/>
    </div>

    <ul class="options full-width" v-if="!disabled && options.length && selectActive">
      <template v-for="option in options">
        <li class="option row full-width g-8" :class="{active:value===option.key}"
            @click="value=option.key; selectActive=false; prefix=option.prefix;">
          <div class="no-flex" v-if="option.prefix" v-html="option.prefix"></div>
          {{ option.value }}
        </li>
      </template>
    </ul>
  </div>
</template>

<style scoped lang="scss">

.select-input {
  width: 100%;
  position: static;
}

.options {
  position: absolute;
  list-style-type: none;
  background: $white;
  color: $dark-black;
  left: 0;
  right: 0;
  top: 41px;
  z-index: 99;
  border: 1px solid $border-grey;
  box-shadow: 0 2px 3px rgba(0, 0, 0, .16);
  max-height: 200px;
  overflow: auto;
  padding: 0;
  scrollbar-width: thin;
  scrollbar-color: $dark-black transparent;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $dark-black;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  .option {
    padding: 15px;
    cursor: pointer;
    font-weight: 400;
    display: flex;

    &.active {
      font-weight: 600;
    }

    &:hover {
      background: $grey;

    }
  }
}

.prefix {
  transform: translate(0px, 4px);
}

input {
  pointer-events: none;
}

svg {
  margin-top: -5px;
  transform: rotate(90deg);
}

.select-container.active {
  svg {
    transform: rotate(-90deg);
  }
}
</style>
